import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BaseAsyncValue } from '@ordersnproducts/modules/shared/models/async-value';
import { getOneClickStandardLotState } from '@ordersnproducts/modules/one-click-order/selectors/one-click-standard-lot.selector';

export class OneClickPreviewStandardLotLoadingProvider extends BaseAsyncValue<boolean> {
  getValue(): Observable<boolean> {
    return this.store.select(getOneClickStandardLotState).pipe(
      filter(state => !!state),
      map(state => state.loading),
    );
  }
}
